// Home's link to the Executive dashboard (CR-041; offer.md call 19: "The Executive dashboard … is the Portfolio report's
// KPI strip plus health by recruiter/function/brand, under Reports, with drill-down to requisitions."). S13 sends it to
// the TA Manager and the Admin only (PLAN D9; his TA Admin and HR Systems Admin fold into the Admin, DC-228 as amended
// 12 Oct 05:29); the whole card opens the tab.

import { Widget } from "@/mc";
import { NAV_ITEM_LABELS } from "@/mc/labels";
import { reportHref } from "@/views/b10/reports/spec";
import type { HomeWidgetView } from "./host";
import { executiveLinkOf, seatsOf } from "./api";
import { REPORT_FAMILY_LABELS } from "./labels";

/** Widget `executive_link` (S13 → S16, frozen; held on the server until C-B10-8). */
export const ExecutiveLink: HomeWidgetView = ({ widgetKey, data }) => {
  const route = executiveLinkOf(data).route || reportHref("executive");
  return (
    <Widget
      id={widgetKey}
      kind="reports"
      roles={seatsOf(widgetKey)}
      title={REPORT_FAMILY_LABELS.executive}
      sub={NAV_ITEM_LABELS.reports}
      icon="reports"
      href={route}
      
    />
  );
};
